import React, { useState, useEffect } from "react";
import { message, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";

import { updateLeadList } from "../../../Slices/salesSlice";
import { setRefreshStatus } from "../../../Slices/salesSlice";
import { useLeadListField } from "./useLeadList";

import { InputField } from "../../../blueplanitUtils/InputField";

// listKey: the window's own lead list (see useLeadListKey) — search is per window.
const SearchInput = ({ clearSearch, setClearSearch, listKey }) => {

    const dispatch = useDispatch();
    const existingFilterObject = useLeadListField(listKey, "filters");
    const refreshStatus = useSelector((state) => state.sales.refreshStatus);
    const [filterSearch, setFilterSearch] = useState('');

    useEffect(() => {
        if (refreshStatus) {
            setFilterSearch(existingFilterObject?.search)
        }
    }, [refreshStatus])

    useEffect(() => {
        if (clearSearch) {
            setFilterSearch('')
        }
        setClearSearch(false)

    }, [clearSearch])

    useEffect(() => {
        if (existingFilterObject.search !== undefined && existingFilterObject.search !== '') {
            setFilterSearch(existingFilterObject.search)
        }
    }, [])

    const handleSearchChange = (event) => {
        let searchText = event.target.value
        setFilterSearch(searchText)

    }

    const handleClear = () => {
        setFilterSearch("") // Clear the search input field and reset state
        dispatch(updateLeadList({
            key: listKey,
            changes: { filters: { ...existingFilterObject, search: "" } }
        }));
    };

    const handleSearchClick = () => {
        if (!filterSearch || !filterSearch.trim()) {
            message.error("Please enter a value before searching."); // Show error message
            return; // Stop execution if the input is empty
        }
        dispatch(setRefreshStatus(null))
        // Back to page 1 so a search from page 5 doesn't land on an empty page.
        dispatch(updateLeadList({
            key: listKey,
            changes: { filters: { ...existingFilterObject, search: filterSearch.trim() }, page: 1 }
        }));
    }

    return (
        <InputField
            placeholder="Search"
            value={filterSearch}
            onChange={(e) => setFilterSearch(e.target.value)}
            onBlur={handleSearchChange}
            onSearch={handleSearchClick}
            allowClear
            onClear={handleClear}
            style={{ width: 200, marginBottom: 16 }}
            enterButton={
                <Button type="primary" style={{ backgroundColor: '#1890ff', borderColor: '#1890ff' }}>
                    <i className="fa fa-search" /> Search
                </Button>
            } // Add a solid button as the enterButton
        />
    );
};

export default SearchInput;
